import React from "react";
import "./SharedStyles.scss";
import { IoMdAlert, IoMdWarning } from "react-icons/io";

interface IProps {
  message: string;
  type: "error" | "warning";
  showOnlyIcon?: boolean;
  compact?: boolean;
}

const EAAlert: React.FC<IProps> = ({ message, type, showOnlyIcon = false, compact = false }) => {
  const icon = type === "error" ? <IoMdAlert /> : <IoMdWarning />;

  const alertClasses = `ea-alert ea-alert--${type} ${showOnlyIcon ? "ea-alert__only-icon" : ""} ${
    compact ? "ea-alert--compact" : ""
  }`.trim();

  if (showOnlyIcon || message === "") {
    return (
      <div className={alertClasses}>
        <span className="ea-alert__icon">{icon}</span>
      </div>
    );
  }

  return (
    <div className={alertClasses}>
      <span className="ea-alert__icon">{icon}</span>
      <span className="ea-alert__message">{message}</span>
    </div>
  );
};

export default EAAlert;
